import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  wrapper: {
    '& p': {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: '20px',
      margin: '0!important'
    },
    '& h2': {
      padding: '35px 0 15px 0',
      fontSize: theme.typography.pxToRem(20),
      margin: 0
    },
    '& h5': {
      fontSize: theme.typography.pxToRem(16),
      paddingTop: 20,
      margin: 0
    },
    '& h3': {
      fontSize: theme.typography.pxToRem(20),
      padding: '40px 0 20px 0',
      fontWeight: 400,
      margin: 0
    },
    '& a': {
      color: '#131947'
    },
    '& ul': {
      margin: '0 0 0 18px',
      padding: 0,
      '& li': {
        fontSize: theme.typography.pxToRem(16),
        color: theme.palette.text.primary,
        fontWeight: 300,
        lineHeight: '20px'
      }
    }
  },
  footer: {
    '& h5': {
      fontSize: theme.typography.pxToRem(16),
      paddingTop: 40,
      margin: 0
    }
  }
}));
